import React, { useState } from 'react';
import styles from './specificationsTab.module.css';
import { Download, Filter } from '../../../../Svg';
import { Menu, MenuItem, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '014px',
  color: '#667085',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  borderRadius: "4px",
  height: "40px",
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AllEnquiresTable = ({data,activeTab}) => {
const navigate = useNavigate()
 



  return (
    <>
      <table className={styles.spectable}>
        <thead>
          <tr>
            <th>Enquiry ID</th>
            <th>Date</th>
            {/* <th>Total</th> */}
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody className={styles.spectbody}>
          {data?.map((record) => (
            <tr key={record._id}>
              <td>
                <span className={styles.edListId}>#{record?.enquiryId}</span>
                {record?.user?.fullName && <span className={styles.edListBy}>by {record.user.fullName}</span>}
              </td>
              <td>{formateDate(record?.createdAt)}</td>
              {/* <td>{record?.total}</td> */}
              <td>
                <span className={`${styles.edBadge} ${record?.status == "NEW" ? styles.edBadgePending : record?.status == "QUOTED" ? styles.edBadgeQuoted : styles.edBadgeDone}`}>
                  {record?.status == "NEW" ? "Pending" : record?.status == "QUOTED" ? "Quoted" : record?.status == "COMPLETED" ? "Completed" : record?.status}
                </span>
              </td>
              <td className={styles.speccheck}>
                <button type="button" className={styles.edViewBtn} onClick={()=>navigate(`userEnquiryDetails/${record?.enquiryId}`,{state:activeTab})}>View Details</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AllEnquiresTable;
